// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSource.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSource component
 */
!(function () {
  var ReportDesignerDataSourceStore = require('logic/Izenda.ReportDesignerDataSourceStore');

  var React = require('react');
  var DataSourceTreeContainer = require('./Izenda.DataSourceTreeContainer');
  var DnDFieldsConfig = require('modules/ReportDesigner/Fields/Izenda.DnDFieldsConfig');
  var DataSourceDetail = require('./Izenda.DataSourceDetail');

  module.exports = {
    setStore: function (store) {
      this.store = store.dataSourceStore;
      this.fieldStore = store.fieldsStore;
    },

    destroy: function (){
      delete this['store'];
      delete this['fieldStore'];
    },

    reloadView: function () {
      return this.store.loadInitial();
    },

    renderMiddlePanel: function () {
      return (
        <DataSourceTreeContainer store={this.store} />
      );
    },

    renderMainContent: function (ref, updateResultsInfo) {
      return (<DataSourceDetail store={this.store} updateResultsInfo={updateResultsInfo} fieldStore={this.fieldStore} ref={ref} uiStore={DnDFieldsConfig.targetOptions}/>);
    }
  };
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.DataSource.jsx